import { React, useEffect, useState } from "react";
import Loader from "./Loader";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import noQLogo from "../assets/icons/NO-QLogo-new.svg";
import { ArrowLeft, ChartLineUp, List, SignOut, Storefront, Ticket, UsersThree, X } from "@phosphor-icons/react";
import { useDispatch, useSelector } from "react-redux";
import { eventActions } from "../redux/actions";

const navIcon = (label = "") => {
    const normalized = label.toLowerCase();
    if (normalized.includes("vendor") || normalized.includes("invitation")) return UsersThree;
    if (normalized.includes("revenue") || normalized.includes("order")) return Ticket;
    if (normalized.includes("insight") || normalized.includes("performance")) return ChartLineUp;
    return Storefront;
};

const PageFrame = ({ isLoading, children, frameLinks, childrenContainerClass = "" }) => {
    const params = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const noqUser = localStorage.getItem("noqEventUser") || sessionStorage.getItem("noqEventUser");
    const userObj = JSON.parse(noqUser || "{}");
    const { isFetchedStoreDetailsSuccess } = useSelector((store) => store.vendor);
    const [isOpen, setIsOpen] = useState(false);

    const logout = () => {
        dispatch(eventActions.resetGetStoreDetailsSuccess());
        localStorage.removeItem("noqEventUser");
        sessionStorage.removeItem("noqEventUser");
        window.dispatchEvent(new Event("storage"));
    };

    useEffect(() => {
        if (!isFetchedStoreDetailsSuccess && params?.storeId) {
            dispatch(eventActions.getStoreDetails(params.storeId, userObj?.token));
        }
    }, [dispatch, params?.storeId, userObj?.token, isFetchedStoreDetailsSuccess]);

    useEffect(() => setIsOpen(false), [params?.eventId, params?.storeId]);

    return (
        <div className="noq-dashboard-shell">
            <header className="noq-mobile-header">
                <img src={noQLogo} alt="NO-Q" />
                <button onClick={() => setIsOpen((open) => !open)} aria-label={isOpen ? "Close navigation" : "Open navigation"} aria-expanded={isOpen}>
                    {isOpen ? <X size={24} /> : <List size={24} />}
                </button>
            </header>

            <aside className={`noq-sidebar ${isOpen ? "noq-sidebar--open" : ""}`} aria-label="Event navigation">
                <div>
                    <div className="noq-sidebar__brand">
                        <img src={noQLogo} alt="NO-Q" />
                        <div>
                            <span>ORGANIZER</span>
                            <strong>{isFetchedStoreDetailsSuccess?.name || "Event workspace"}</strong>
                        </div>
                    </div>

                    <button className="noq-sidebar__back" onClick={() => {
                        dispatch(eventActions.resetGetStoreDetailsSuccess());
                        navigate("/dashboard");
                    }}>
                        <ArrowLeft size={17} />
                        All events
                    </button>

                    <nav className="noq-sidebar__nav">
                        <p className="noq-sidebar__label">EVENT WORKSPACE</p>
                        {frameLinks?.map((link, idx) => {
                            const Icon = navIcon(link.text);
                            return (
                                <NavLink key={`${link.text}-${idx}`} to={link.url} className={`noq-sidebar__link ${link.isActive ? "is-active" : ""}`} onClick={() => setIsOpen(false)}>
                                    <Icon size={19} weight={link.isActive ? "fill" : "regular"} />
                                    <span>{link.text}</span>
                                </NavLink>
                            );
                        })}
                    </nav>
                </div>

                <button className="noq-sidebar__logout" onClick={logout}>
                    <SignOut size={19} />
                    Log out
                </button>
            </aside>

            {isOpen && <button className="noq-sidebar-backdrop" aria-label="Close navigation" onClick={() => setIsOpen(false)} />}

            <main className={`noq-dashboard-main ${childrenContainerClass}`}>
                {isLoading ? (
                    <div className="noq-dashboard-loader">
                        <Loader color="#CEF24E" />
                        <span>Loading workspace</span>
                    </div>
                ) : children}
            </main>
        </div>
    );
};

export default PageFrame;
